<form
  class="flex flex-col w-full gap-8"
  [formGroup]="form"
  (ngSubmit)="onSubmit($any(form.value))"
  >

  <!-- STALL SECTION -->
  <div>
    <header
      class="action-header uppercase mt-10 text-light text-sm font-medium">{{ '#REPORT_FORM.SECTION_HEADERS.STALL' | translate }}
    </header>
    <div class="control no-margin">
      <label class="soft-label top required">{{ '#REPORT_FORM.CONTROLS.STALL' | translate }}</label>
      <soft-select formControlName="stable" (valueChange)="onStableChange(stable.value())" #stable>
        @for (stable of stables(); track stable.id) {
          <soft-select-option [value]="stable">
            {{ stable.stall }}
          </soft-select-option>
        }
      </soft-select>
    </div>

    <ng-template let-entity="entity" #objectTemplate>
      <span class="trim-text display-block">{{ entity.id }}
        @if (entity.kurzbez) {
          - {{ entity.kurzbez }}
        }</span>
      </ng-template>
    </div>


    <!-- WEIGHT REPORT FORM FOR SELECTED STALL -->
    <div>
      <header
        class="action-header uppercase mt-4 text-light text-sm font-medium">{{ ('#REPORT_FORM.SECTION_HEADERS.FORM' | translate) + (stable.value()?.stall || '') }}
      </header>

      @if (stable.value() && loadingDefault()) {
        <div class="flex flex-col w-full gap-3">
          <div class="flex flex-row w-full flex-nowrap gap-4">
            <div class="flex flex-col w-full">
              <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.SET_DATE' | translate }}</label>
              <soft-input [readonly]="true" [value]="form.value.setDate | format:'DATE.DEFAULT'"></soft-input>
            </div>
            <div class="flex flex-col w-full">
              <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.DAY' | translate }}</label>
              <soft-input class="align-right" [readonly]="true"
              [value]="form.value.day | format:'NUMBER.INTEGER'"></soft-input>
            </div>
          </div>
          <div class="flex flex-row w-full flex-nowrap gap-4">
            <div class="flex flex-col w-full">
              <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.QUANTITY' | translate }}</label>
              <soft-number-input
                softFieldValidation
                class="align-right"
                formControlName="quantity">
              </soft-number-input>
              <!--<soft-validation-container *ngIf="form.controls.quantity.touched"
              [validation]="form|validationMessage:'quantity'"
            class="soft-property-validation"></soft-validation-container>-->
          </div>
          <div class="flex flex-col w-full">
            <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.WEIGHT' | translate }}</label>
            <soft-number-input
              softFieldValidation
              class="align-right"
              [format]="'NUMBER.DECIMAL_2'"
              formControlName="weight">
            </soft-number-input>
            <!--<soft-validation-container *ngIf="form.controls.weight.touched"
            [validation]="form|validationMessage:'weight'"
          class="soft-property-validation"></soft-validation-container>-->
        </div>
      </div>
      <div class="flex flex-row w-full flex-nowrap gap-4">
        <div class="flex flex-col w-full gap-3">
          <div class="flex flex-col w-full">
            <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.WEIGHT_LOSS' | translate }}</label>
            <soft-number-input
              softFieldValidation
              class="align-right"
              [format]="'NUMBER.DECIMAL_1'"
              formControlName="loss">
            </soft-number-input>
            <!--<soft-validation-container *ngIf="form.controls.loss.touched"
            [validation]="form|validationMessage:'loss'"
          class="soft-property-validation"></soft-validation-container>-->
        </div>
        <div class="flex flex-col w-full">
          <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.SALMONELLAE.LABEL' | translate }}</label>
          <soft-radio-group
            class="flex flex-row"
            formControlName="salmonellae">
            <div class="w-100">
              <soft-radio-option [value]="false" [labelPosition]="'after'">
                <span class="ml-2">{{ '#REPORT_FORM.CONTROLS.SALMONELLAE.NO' | translate }}</span>
              </soft-radio-option>
            </div>
            <div class="w-100">
              <soft-radio-option [value]="true" [labelPosition]="'after'">
                <span class="ml-2">{{ '#REPORT_FORM.CONTROLS.SALMONELLAE.YES' | translate }}</span>
              </soft-radio-option>
            </div>
          </soft-radio-group>
        </div>
      </div>
      <div class="flex flex-col w-full">
        <label class="soft-label top">{{ '#REPORT_FORM.CONTROLS.ADDITIONAL_INFO' | translate }}</label>
        <soft-multiline-input formControlName="info" [canResize]="false" [lines]="5"></soft-multiline-input>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-end mt-3">
    <button class="soft-button primary mt-3" type="submit"
      [disabled]="!form.valid">{{ '#REPORT_FORM.CONTROLS.SUBMIT' | translate }}
    </button>
  </div>
} @else {
  <div class="flex flex-col items-center no-stall-info">
    <p class="info-header">{{ '#REPORT_FORM.PLACEHOLDER.TITLE' | translate }}</p>
    <p class="info-secondary">{{ '#REPORT_FORM.PLACEHOLDER.SECONDARY_TEXT' | translate }}</p>
  </div>
}


</div>
</form>
